import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DirectoryAccessService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/directoryaccess').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    public get(module: string): Observable<DirectoryModule[]> {
        const params = new HttpParams().set('module', module);
        return this.http.get<DirectoryModule[]>(`${this._url}`, {
            params: params,
        });
    }
    public getMenu(): Observable<DirectoryMenu> {
        return this.http.get<DirectoryMenu>(`${this._url}/menu`);
    }
}

export interface DirectoryModule {
    applicationPageKey: number;
    applicationPageTypeKey: number;
    parentApplicationPageTypeKey: number;
    name: string;
    description: string;
    icon: string;
    routerURL: string;
    isLocked: boolean;
    module: string;
    expanded: boolean;
    cardImgPath: string;
    hasDivider: boolean;
}

export interface DirectoryMenu {
    modules: DirectoryMenuModel[];
}
export interface DirectoryMenuModel {
    page: DirectoryModule;
    subPages: DirectoryModule[];
}
